module.exports = __webpack_public_path__ + "static/images/event/software_update_urgent.png";